/**
 * Cookie取得関数
 * @function getCookie
 * @param  {string} key キー名
 * @return {string} Cookieの値
Use
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
const hogeData = getCookie('hogeData') // Cookie取得
 */
const getCookie = (key) => {
  if (document.cookie === '') {
    return false
  }

  const cookieList = document.cookie.split(';')

  for (const cookiePart of cookieList) {
    const cookie = cookiePart.split('=')
    const cookieKey = cookie[0].replace(' ', '') // 半角スペースが混ざっているので取り除く
    const cookieValue = cookie[1]

    if (cookieKey === key) {
      // 取り出したいkeyと合致したら
      // 元の文字列 = エスケープ文字を正しく置き換えた文字列
      return decodeURIComponent(cookieValue)
    }
  }
}
export default getCookie
